var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('ChatMultiSala')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }